import { createBrowserRouter, Navigate } from 'react-router-dom';
import Routes from './Routes.ts';
import { transformRouterConfig } from '@/router/transformRouter.tsx';
import Default from '@/layouts/Default/Default.tsx';
import HomePage from '@/pages/HomePage.tsx';
import ConsentsPage from '@/pages/settings/ConsentsPage.tsx';
import ProjectsPage from '@/pages/settings/ProjectsPage.tsx';
import SubscriptionPage from '@/pages/settings/SubscriptionPage.tsx';

const router = createBrowserRouter(
  transformRouterConfig([
    {
      path: '/',
      element: <Default.Layout mainClassName="!py-0" />,
      middleware: ['loggedIn', 'onboardingCompleted'],
      children: [
        {
          path: Routes.DASHBOARD,
          element: <HomePage />,
        },
      ],
    },
    {
      path: '/',
      element: <Default.Layout />,
      middleware: ['loggedIn', 'onboardingCompleted'],
      children: [
        {
          path: Routes.SETTINGS__CONSENTS,
          element: <ConsentsPage />,
        },
        {
          path: Routes.SETTINGS__PROJECTS,
          element: <ProjectsPage />,
        },
        {
          path: Routes.SETTINGS__SUBSCRIPTION,
          element: <SubscriptionPage />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to={Routes.DASHBOARD} />,
    },
  ])
);

export default router;
